
import React, { useEffect, useState } from "react";
import styled from "styled-components";

/* const reviews = [
  { id: 1, name: "Ravi", rating: 4.5, comment: "Great product, works as expected." },
  { id: 2, name: "Anjali", rating: 5, comment: "Absolutely loved it!" },
  { id: 3, name: "Mohit", rating: 3, comment: "It's okay, not the best." },
];

const getAverageRating = () => {
  if (!reviews.length) return 0;
  const total = reviews.reduce((acc, r) => acc + r.rating, 0);
  return (total / reviews.length).toFixed(1);
};
 */




const Reviews = ({SKUID}) => {

  const [loading, setLoading] = React.useState(true);
  const [averageRating, setAverageRating] = React.useState(0);
  const [totalCount,setTotalCount]=useState()
  const [reviews, setReviews] = React.useState([]);
  
 

const calculateAverageRating = (data) => {
  const totalCount = data.reduce((sum, item) => sum + item.count, 0);
  if (totalCount === 0) return 0;

  const totalRating = data.reduce(
    (sum, item) => sum + item.rating * item.count,
    0
  );

  return (totalRating / totalCount).toFixed(1);
};


const getRating = async () => {
  const rating = await  fetch(`https://accountdev.clan.business/review/product/count?sku=${SKUID}`);
  if (!rating.ok) {
    throw new Error("Network response was not ok");
  }
  const data = await rating.json();
  console.log(data);

  setAverageRating(calculateAverageRating(data));
  
  return data;

  
};

const getReviews = async () => {
  const rating = await  fetch(`https://accountdev.clan.business/review/product?sku=${SKUID}`);
  if (!rating.ok) {
    throw new Error("Network response was not ok");
  }
  const data = await rating.json();
  console.log(data);

  setReviews(data.reviewList);
  setTotalCount(data.count)
  
  return data;

  
};

useEffect(() => {
  setLoading(true);
  getRating().then(() => {
     getReviews().then(() => {
    setLoading(false);  
  });
  });
  
}, [SKUID]);

  const rating = getRating();



  return (
    <Wrapper>
      <Heading>Customer Reviews</Heading>
      <AverageRating>
        <Stars>{renderStars(averageRating)}</Stars>
        <RatingText>{averageRating?`${averageRating} out of 5}`:"Not rated"}</RatingText>
        <Count>{totalCount} Ratings & Reviews</Count>
      </AverageRating>

      <ReviewList>
        {reviews.map((r) => (
          <ReviewCard key={r.fullName}>
            <UserName>{r.fullName}</UserName>
            <ReviewStars>{renderStars(r.rating)}</ReviewStars>
            <Comment>{r.comment}</Comment>
          </ReviewCard>
        ))}
      </ReviewList>
    </Wrapper>
  );
};

export default Reviews;

// Helper to render stars
const renderStars = (rating) => {
  const stars = [];
  const rounded = Math.floor(rating);
  for (let i = 0; i < 5; i++) {
    if (i < rounded) stars.push("★");
    else stars.push("☆");
  }
  return stars.join(" ");
};

// Styled components

const Wrapper = styled.div`
 width:100%;
  margin: 2rem auto;
  padding: 1rem;
  background: #fff;
`;

const Heading = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
`;

const AverageRating = styled.div`
  border-bottom: 1px solid #ddd;
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
`;

const Stars = styled.div`
  font-size: 1.2rem;
  color: #ff9800;
`;

const RatingText = styled.div`
  font-weight: bold;
  margin-top: 0.3rem;
`;

const Count = styled.div`
  color: #666;
  font-size: 0.9rem;
`;

const ReviewList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const ReviewCard = styled.div`
  padding: 1rem;
  background: #f9f9f9;
  border-radius: 10px;
`;

const UserName = styled.div`
  font-weight: bold;
  margin-bottom: 0.4rem;
`;

const ReviewStars = styled.div`
  color: #ff9800;
  margin-bottom: 0.4rem;
`;

const Comment = styled.p`
  margin: 0;
  font-size: 0.95rem;
`;

